// url-shape — "isto é uma URL http(s) absoluta?", e SÓ isso.
//
// DONO ÚNICO da forma. Existiam três implementações do mesmo teste em três
// arquivos, duas delas com o MESMO NOME (`isValidServerUrl` em
// `manual-source-form.ts` e em `mobile/mobile-source.ts`) e SEMÂNTICAS OPOSTAS pro
// vazio: lá vazio é válido (o campo é opcional naquele formulário), aqui era
// inválido (a URL é obrigatória). Importar do módulo errado trocava a regra em
// silêncio — o typecheck não vê diferença entre `(string) => boolean` e
// `(string) => boolean`, e o teste de cada lado continuava verde.
//
// A separação que resolve: a FORMA mora aqui (uma implementação), e a POLÍTICA de
// campo vazio fica em quem valida o formulário, escrita por extenso. Sem nome
// repetido, não há troca silenciosa.

/**
 * URL absoluta http(s)? Vazio é FALSE — "não informou" não é uma URL; quem tratar
 * o campo como opcional decide isso ANTES de perguntar a forma.
 *
 * Compat Chr38/Chr53 (piso da TV): `new URL` existe nos dois e é o que as três
 * cópias já usavam. Nada de regex com `\p{...}`/flag `u`/lookbehind aqui.
 */
export function isHttpUrl(value: string): boolean {
  const v = value.trim()
  if (!v) return false
  try {
    const u = new URL(v)
    return u.protocol === 'http:' || u.protocol === 'https:'
  } catch {
    return false
  }
}
